import { stringifyNumericRange } from '@iris/modules/module-filters-v2/utils';
import { defaultChipRenderingOptions } from './default-chip-rendering-options';

export const NUMERIC_RANGE_CHIP_RENDERING_OPTIONS = defaultChipRenderingOptions(stringifyNumericRange);
